// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e7f0c447","513":"eb084301","703":"18bfbe79"}[chunkId] + ".chunk.js";
};